export const statisticsConsts = {
  LOAD_REQUEST: '[Statistics] LOAD_REQUEST',
  LOAD_SUCCESS: '[Statistics] LOAD_SUCCESS',
  LOAD_FAILURE: '[Statistics] LOAD_FAILURE',
  AVG_LOAD_REQUEST: '[Statistics] AVG_LOAD_REQUEST',
  AVG_LOAD_SUCCESS: '[Statistics] AVG_LOAD_SUCCESS',
  AVG_LOAD_FAILURE: '[Statistics] AVG_LOAD_FAILURE'
};
